<template>
    <fade-loader :loading="!value.loaded" :loaded="value.loaded">
        <div class="toolbox-content">
            <v-expansion-panels accordion class="sr-accordion" :value="value.objects.length === 1 ? 0 : null" v-if="getLayers.length">
                <v-expansion-panel v-for="layer in getLayers" :key="layer.id">
                    <v-expansion-panel-header>
                        <label>
                            <i></i>
                            <span>
                            <simple-svg
                                    :filepath="layer.iconUrl"
                                    :fill="layer.color"
                                    :stroke="layer.stroke"
                            ></simple-svg>
                            <div class="layer-title">{{ layer.title }}</div>
                        </span>
                        </label>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                        <ul class="properties">
                            <li v-for="item in filteredItems(layer.id)" :key="item.id" :class="{'publish-error': item.errors}">
                                <div class="preview-image img" @click="editObject(item)">
                                    <img :src="getImageUrl(item)"/>
                                </div>
                                <div class="content">
                                    <div class="heading" @click="editObject(item)"> {{ item.field_flaechenId.value }}</div>
                                    <div class="content" @click="editObject(item)">
                                        <span>
                                          {{ item.field_titlePublishImmoscout.value }}<br v-show="item.field_titlePublishImmoscout.value"/>
                                          {{ getStrasseAndHausnummer(item) }} - {{ getKommuneAndGemarkung(item) }}
                                        </span>
                                        <div class="error-chip" v-if="item.errors">erforderliche Felder leer</div>
                                    </div>
                                </div>
                              <button class="btn-icon icon-preview" @click="editPreview(item)"></button>
                            </li>
                        </ul>
                    </v-expansion-panel-content>
                </v-expansion-panel>
            </v-expansion-panels>
            <div v-else>
                Keine Objekte zum veröffentlichen vorhanden
            </div>
        </div>
    </fade-loader>
</template>

<script>
  import GeoObjectAPI from '@/api/geoObject'
  import ImmoScoutPreview from '@/models/ImmoScoutPreview'
  import PreviewHeaderComponent from '@/components/toolbox/immoscoutpreview/Header'

  export default {
    props: {
      value: {
        type: Object,
        required: true
      },
      loading: {
        type: Boolean,
        default: false
      }
    },
    methods: {
      editObject (object) {
        this.$store.dispatch('geoview/addActiveObject', { id: object.id, source: object.layer + 'Source' })
        this.$toolbox.openStack({
          item: object,
          onConfirm: async (toolbox) => {
            // hier die daten zum server senden
            // toolbox.contentData gibt das item zurück (GeoObjectCollection)
            let result = await GeoObjectAPI.udpate(toolbox.contentData.id, toolbox.contentData)

            toolbox.contentData.update(result.data)

            return result
          },
          onConfirmError: (toolbox, error) => {
            // hier den fehler in die toolbox setzen
            toolbox.errorData = error.response.data.error
          }
        }).then((result) => {
          if (typeof result.content === 'object' && result.content) {
            if (typeof result.content.isDeleted !== 'undefined' && result.content.isDeleted) {
              this.$delete(this.value.objects, this.value.objects.indexOf(object))
            }
          }
          if (result.confirmed) {
            // prüfen, ob der verlffentlichen haken deaktiviert wurde --> wenn ja, dann komplett aus unserem context hauen
            if (result.content.field_publishImmoscout.value !== true) {
              // kick it
              this.value.objects.splice(this.value.objects.indexOf(object), 1)
            } else {
              this.$set(this.value.objects, this.value.objects.indexOf(object), result.content)
            }
            this.value.refreshObjects()
            this.$alert.success('Erfolgreich gespeichert')
          }

          this.$store.dispatch('geoview/removeActiveObject', { id: object.id })
        }).catch(() => {
          this.$store.dispatch('geoview/removeActiveObject', { id: object.id })
        })
      },
      editPreview (object) {
        this.$store.dispatch('geoview/addActiveObject', { id: object.id, source: object.layer + 'Source' })
        this.$toolbox.openStack({
          item: new ImmoScoutPreview({ ...object, loaded: false }),
          layoutOptions: {
            headerComponent: PreviewHeaderComponent
            // footerComponent: ImportFooterComponent
          },
          onConfirm: async (toolbox) => {
            // hier die daten zum server senden
            // toolbox.contentData gibt das item zurück (GeoObjectCollection)
            let result = await GeoObjectAPI.udpate(toolbox.contentData.id, toolbox.contentData, true)

            toolbox.contentData.update(result.data)

            return result
          },
          onConfirmError: (toolbox, error) => {
            // hier den fehler in die toolbox setzen
            toolbox.errorData = error.response.data.error
          }
        }).then((result) => {
          if (typeof result.content === 'object' && result.content) {
            if (typeof result.content.isDeleted !== 'undefined' && result.content.isDeleted) {
              this.$delete(this.value.objects, this.value.objects.indexOf(object))
            }
          }
          if (result.confirmed) {
            // prüfen, ob der verlffentlichen haken deaktiviert wurde --> wenn ja, dann komplett aus unserem context hauen
            if (result.content.field_publishImmoscout.value !== true) {
              // kick it
              this.value.objects.splice(this.value.objects.indexOf(object), 1)
            } else {
              this.$set(this.value.objects, this.value.objects.indexOf(object), result.content)
            }
            this.value.refreshObjects()
            this.$alert.success('Erfolgreich gespeichert')
          }
          this.$store.dispatch('geoview/removeActiveObject', { id: object.id })
        }).catch(() => {
          this.$store.dispatch('geoview/removeActiveObject', { id: object.id })
        })
      }
    },
    computed: {
      filteredItems () {
        return (layerId) => {
          return this.value.objects.filter((item) => item.layer === layerId)
        }
      },
      getLayers () {
        let layers = []
        let layerIds = []
        for (let i = 0; i < this.value.objects.length; i++) {
          if (!layerIds.includes(this.value.objects[i].layer)) {
            layerIds.push(this.value.objects[i].layer)
            layers.push(this.$store.getters['layer/get'](this.value.objects[i].layer))
          }
        }
        return layers
      },
      getKommuneAndGemarkung () {
        return (object) => {
          let text = ''
          if (typeof object.field_kommune === 'object') {
            // eslint-disable-next-line eqeqeq
            let kommune = object.field_kommune.options.find((item) => item.value == object.field_kommune.value)
            text += kommune.label
          }
          if (typeof object.field_gemarkung === 'object') {
            // eslint-disable-next-line eqeqeq
            let gemarkung = object.field_gemarkung.options.find((item) => item.value == object.field_gemarkung.value[0])
            if (text) {
              text += ', '
            }
            text += gemarkung.label
          }

          return text
        }
      },
      getStrasseAndHausnummer () {
        return (object) => {
          let text = ''
          if (typeof object.field_strasseHausnummer === 'object' && object.field_strasseHausnummer.value) {
            text += object.field_strasseHausnummer.value
          }
          if (typeof object.field_hausnummer === 'object' && object.field_hausnummer.value) {
            if (text) {
              text += ', '
            }
            text += object.field_hausnummer.value
          }

          return text
        }
      },
      getImageUrl () {
        return (object) => {
          if (typeof object.field_image === 'object' && object.field_image.value && object.field_image.value[0]) {
            return object.field_image.value[0].url
          }
        }
      }
    }
  }
</script>

<style scoped>

</style>
